var exports = {
  "MY": "x86173eed--affb11--page",
  "HU": "x86173eed--affb11--aside",
  "iW": "x86173eed--affb11--main",
  "UE": "x86173eed--affb11--arrow",
  "fR": "x86173eed--affb11--sticky-cont",
  "Zl": "x86173eed--affb11--sticky-inner",
  "yu": "x86173eed--affb11--sticky-inner-visible",
  "yJ": "x86173eed--affb11--links",
  "DD": "x86173eed--affb11--title",
  "rf": "x86173eed--affb11--body",
};

module.exports = exports;
